var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-user-edit"}},[_c('bread-crumbs',{attrs:{"title":_vm.$t('CreateVisitPoint'),"subTitle":_vm.$t('general.SubTitleZonification'),"sizeTitle":30,"lineHeightTitle":37,"sizeSubTitle":15,"lineHeightSubTitle":18}}),(
			_vm.visitpointCreatePermission &&
			_vm.objectRPermission &&
			_vm.typeConfigRPermission &&
			_vm.statusRPermission &&
			_vm.roleRPermission
		)?_c('visit-point-create-tab-account',{attrs:{"visit_point":_vm.visitPoint,"manual_data_id":_vm.manualDataId,"upload_file_id":_vm.uploadFileId}}):_c('not-permission',{attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }